import { render, staticRenderFns } from "./SkeletonHorizontalList.vue?vue&type=template&id=48f3b4ee&scoped=true&"
import script from "./SkeletonHorizontalList.vue?vue&type=script&lang=js&"
export * from "./SkeletonHorizontalList.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonHorizontalList.vue?vue&type=style&index=0&id=48f3b4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3b4ee",
  null
  
)

export default component.exports